import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import classes from './MotorDataPhaseltems.css';
import MotorDataPhaseItem from './MotorDataPhaseItem/MotorDataPhaseItem';
import translations from '../../../assets/data/LocalizedStrings/LocalizedStrings.json';

class MotorDataPhaseltems extends Component {
  phaseSelectionHandler = key => {
    this.props.history.push(`/motor-data/${key}`);
  };

  render() {
    const { country, language } = this.props;
    const PHASE_OPTIONS = require(`../../../assets/data/AppData/${country}/MotorData/PhaseOptions.json`);

    const motorDataListItems = PHASE_OPTIONS.map(mdItem => {
      const currentPath = `${mdItem[0].toUpperCase()}${mdItem[1]}`;
      return (
        <MotorDataPhaseItem
          key={mdItem[0] + mdItem[1]}
          phase={translations[language][mdItem[0]]}
          voltage={mdItem[1]}
          selected={() => this.phaseSelectionHandler(currentPath)}
        />
      );
    }).reduce((arr, el) => arr.concat(el), []);

    return (
      <ul className={classes.MotorDataPhaseItems}>{motorDataListItems}</ul>
    );
  }
}

MotorDataPhaseltems.propTypes = {
  country: PropTypes.string.isRequired,
  language: PropTypes.string.isRequired
};
export default withRouter(MotorDataPhaseltems);
